export const api = "https://aluu-satuu.kg/api";
